/**
 * Maps admin URL paths to required module permissions.
 * null = any authenticated admin role, undefined = full access only.
 */

export const ADMIN_ROUTE_RULES = [
  { prefix: '/admin/dashboard', module: null },
  { prefix: '/admin/users/customers', module: 'customers' },
  { prefix: '/admin/users/businesses', module: 'businesses' },
  { prefix: '/admin/posts', module: 'posts_management' },
  { prefix: '/admin/reviews', module: 'reviews_management' },
  { prefix: '/admin/communication', module: 'messages' },
  { prefix: '/admin/messaging', module: 'messages' },
  { prefix: '/admin/messages', module: 'messages' },
  { prefix: '/admin/quotes', module: 'quotes' },
  { prefix: '/admin/moderation', module: 'moderation' },
  { prefix: '/admin/verification', module: 'compliance' },
  { prefix: '/admin/fraud', module: 'fraud_security' },
  { prefix: '/admin/security', module: 'fraud_security' },
  { prefix: '/admin/support', module: 'support_tickets' },
  { prefix: '/admin/billing', module: 'billing_subscriptions' },
  { prefix: '/admin/finance', module: 'billing_subscriptions' },
  { prefix: '/admin/pricing-plans', module: 'pricing_plans' },
  { prefix: '/admin/analytics', module: 'analytics' },
  { prefix: '/admin/reports', module: 'reports' },
  { prefix: '/admin/content', module: 'content' },
  { prefix: '/admin/trade-categories', module: 'trade_categories_management' },
  { prefix: '/admin/configuration/keywords', module: 'keywords_management' },
  { prefix: '/admin/keywords', module: 'keywords_management' },
  { prefix: '/admin/configuration', module: 'configuration' },
  { prefix: '/admin/system-logs', module: 'system_logs' },
  { prefix: '/admin/settings/team-members', module: 'team_members' },
  { prefix: '/admin/settings/history', module: 'change_history' },
  { prefix: '/admin/settings/rbac', module: undefined },
  { prefix: '/admin/settings', module: 'settings' },
  { prefix: '/admin/integrations', module: 'integrations' },
  { prefix: '/admin/form-inventory', module: 'form_inventory' },
  { prefix: '/admin/appeals', module: 'appeals' },
  { prefix: '/admin/licences-badges-trade-tickets', module: 'compliance_items_management' },
  { prefix: '/admin/verifications', module: 'compliance' },
];

const normalizeAdminPath = (pathname) => (pathname || '/').replace(/\/+$/, '') || '/';

const rulesByLongestPrefix = [...ADMIN_ROUTE_RULES].sort(
  (a, b) => b.prefix.length - a.prefix.length,
);

export function getRequiredModuleForAdminPath(pathname) {
  const path = normalizeAdminPath(pathname);
  const rule = rulesByLongestPrefix.find(
    (entry) => path === entry.prefix || path.startsWith(`${entry.prefix}/`),
  );
  if (!rule) return undefined;
  return rule.module;
}

/** True when the path is an Add / create screen (not list or detail/edit). */
export function isAdminAddPath(pathname) {
  const path = normalizeAdminPath(pathname);
  if (path.endsWith('/add') || path.endsWith('/new')) return true;
  return /\/(add|new)(\/|$)/.test(path);
}
